module.exports = __webpack_public_path__ + "img/img12.a82c4634.svg";